import { render, staticRenderFns } from "./BIProduct.vue?vue&type=template&id=2c09a1fc&scoped=true"
import script from "./BIProduct.vue?vue&type=script&lang=js"
export * from "./BIProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09a1fc",
  null
  
)

export default component.exports